export var isNumber = function (value) {
    var rslt = value * 1;
    if (rslt > 0) {
        return true;
    }
    else {
        return false;
    }
};
